var v = "5.7.11";
var fr = 29.9700012207031;
var ip = 0;
var op = 120.0000048877;
var w = 468;
var h = 468;
var nm = "Chain noout";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Fill 2",
        sr: 1,
        ks: {
            o: {
                a: 1,
                k: [
                    {
                        i: {
                            x: [
                                0.667
                            ],
                            y: [
                                1
                            ]
                        },
                        o: {
                            x: [
                                0.333
                            ],
                            y: [
                                0
                            ]
                        },
                        t: 0,
                        s: [
                            100
                        ]
                    },
                    {
                        t: 15.0000006109625,
                        s: [
                            0
                        ],
                        h: 1
                    }
                ],
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233,
                    233,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    2500,
                    2500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "a",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ],
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                127.025
                            ]
                        ],
                        o: [
                            [
                                -127.025,
                                0
                            ],
                            [
                                0,
                                127.025
                            ],
                            [
                                127.025,
                                0
                            ],
                            [
                                0,
                                -127.025
                            ]
                        ],
                        v: [
                            [
                                2500,
                                2270
                            ],
                            [
                                2270,
                                2500
                            ],
                            [
                                2500,
                                2730
                            ],
                            [
                                2730,
                                2500
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                ty: "gr",
                                it: [
                                    {
                                        ty: "gr",
                                        it: [
                                            {
                                                ty: "gr",
                                                it: [
                                                    {
                                                        ty: "gr",
                                                        it: [
                                                            {
                                                                ind: 0,
                                                                ty: "sh",
                                                                ix: 1,
                                                                ks: {
                                                                    a: 0,
                                                                    k: {
                                                                        i: [
                                                                            [
                                                                                -127.025,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -127.025
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                127.026,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                127.026
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ]
                                                                        ],
                                                                        o: [
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                127.026,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                127.026
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                -127.025,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -127.025
                                                                            ]
                                                                        ],
                                                                        v: [
                                                                            [
                                                                                0,
                                                                                -230
                                                                            ],
                                                                            [
                                                                                0,
                                                                                -230
                                                                            ],
                                                                            [
                                                                                230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                0,
                                                                                230
                                                                            ],
                                                                            [
                                                                                0,
                                                                                230
                                                                            ],
                                                                            [
                                                                                -230,
                                                                                0
                                                                            ],
                                                                            [
                                                                                -230,
                                                                                0
                                                                            ]
                                                                        ],
                                                                        c: true
                                                                    },
                                                                    ix: 2
                                                                },
                                                                nm: "Path 1",
                                                                mn: "ADBE Vector Shape - Group",
                                                                hd: false
                                                            },
                                                            {
                                                                ty: "fl",
                                                                c: {
                                                                    a: 0,
                                                                    k: [
                                                                        1,
                                                                        1,
                                                                        1,
                                                                        1
                                                                    ],
                                                                    ix: 4
                                                                },
                                                                o: {
                                                                    a: 0,
                                                                    k: 100,
                                                                    ix: 5
                                                                },
                                                                r: 1,
                                                                bm: 0,
                                                                nm: "Fill 1",
                                                                mn: "ADBE Vector Graphic - Fill",
                                                                hd: false
                                                            },
                                                            {
                                                                ty: "tr",
                                                                p: {
                                                                    a: 0,
                                                                    k: [
                                                                        0,
                                                                        0
                                                                    ],
                                                                    ix: 2
                                                                },
                                                                a: {
                                                                    a: 0,
                                                                    k: [
                                                                        0,
                                                                        0
                                                                    ],
                                                                    ix: 1
                                                                },
                                                                s: {
                                                                    a: 0,
                                                                    k: [
                                                                        100,
                                                                        100
                                                                    ],
                                                                    ix: 3
                                                                },
                                                                r: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 6
                                                                },
                                                                o: {
                                                                    a: 0,
                                                                    k: 100,
                                                                    ix: 7
                                                                },
                                                                sk: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 4
                                                                },
                                                                sa: {
                                                                    a: 0,
                                                                    k: 0,
                                                                    ix: 5
                                                                },
                                                                nm: "Transform"
                                                            }
                                                        ],
                                                        nm: "Rectangle",
                                                        np: 2,
                                                        cix: 2,
                                                        bm: 0,
                                                        ix: 1,
                                                        mn: "ADBE Vector Group",
                                                        hd: false
                                                    },
                                                    {
                                                        ty: "tr",
                                                        p: {
                                                            a: 0,
                                                            k: [
                                                                500,
                                                                500
                                                            ],
                                                            ix: 2
                                                        },
                                                        a: {
                                                            a: 0,
                                                            k: [
                                                                0,
                                                                0
                                                            ],
                                                            ix: 1
                                                        },
                                                        s: {
                                                            a: 0,
                                                            k: [
                                                                100,
                                                                100
                                                            ],
                                                            ix: 3
                                                        },
                                                        r: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 6
                                                        },
                                                        o: {
                                                            a: 0,
                                                            k: 100,
                                                            ix: 7
                                                        },
                                                        sk: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 4
                                                        },
                                                        sa: {
                                                            a: 0,
                                                            k: 0,
                                                            ix: 5
                                                        },
                                                        nm: "Transform"
                                                    }
                                                ],
                                                nm: "icon/2tone/bank",
                                                np: 1,
                                                cix: 2,
                                                bm: 0,
                                                ix: 1,
                                                mn: "ADBE Vector Group",
                                                hd: false
                                            },
                                            {
                                                ty: "tr",
                                                p: {
                                                    a: 0,
                                                    k: [
                                                        500,
                                                        500
                                                    ],
                                                    ix: 2
                                                },
                                                a: {
                                                    a: 0,
                                                    k: [
                                                        0,
                                                        0
                                                    ],
                                                    ix: 1
                                                },
                                                s: {
                                                    a: 0,
                                                    k: [
                                                        100,
                                                        100
                                                    ],
                                                    ix: 3
                                                },
                                                r: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 6
                                                },
                                                o: {
                                                    a: 0,
                                                    k: 100,
                                                    ix: 7
                                                },
                                                sk: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 4
                                                },
                                                sa: {
                                                    a: 0,
                                                    k: 0,
                                                    ix: 5
                                                },
                                                nm: "Transform"
                                            }
                                        ],
                                        nm: "Group",
                                        np: 1,
                                        cix: 2,
                                        bm: 0,
                                        ix: 1,
                                        mn: "ADBE Vector Group",
                                        hd: false
                                    },
                                    {
                                        ty: "tr",
                                        p: {
                                            a: 0,
                                            k: [
                                                500,
                                                500
                                            ],
                                            ix: 2
                                        },
                                        a: {
                                            a: 0,
                                            k: [
                                                0,
                                                0
                                            ],
                                            ix: 1
                                        },
                                        s: {
                                            a: 0,
                                            k: [
                                                100,
                                                100
                                            ],
                                            ix: 3
                                        },
                                        r: {
                                            a: 0,
                                            k: 0,
                                            ix: 6
                                        },
                                        o: {
                                            a: 0,
                                            k: 100,
                                            ix: 7
                                        },
                                        sk: {
                                            a: 0,
                                            k: 0,
                                            ix: 4
                                        },
                                        sa: {
                                            a: 0,
                                            k: 0,
                                            ix: 5
                                        },
                                        nm: "Transform"
                                    }
                                ],
                                nm: "icon/2tone/bank",
                                np: 1,
                                cix: 2,
                                bm: 0,
                                ix: 1,
                                mn: "ADBE Vector Group",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        500,
                                        500
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "lending-platforms",
                        np: 1,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "usecase-accept1",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "chain bottom 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    258.639,
                    258.609,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "s",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                -26.152,
                                -26.403
                            ],
                            [
                                15.152,
                                -26.829
                            ],
                            [
                                15.152,
                                -62.597
                            ],
                            [
                                -26.152,
                                -62.171
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.275
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.275
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.275
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.275
                                    ]
                                ],
                                v: [
                                    [
                                        -25.667,
                                        -46.082
                                    ],
                                    [
                                        25.667,
                                        -46.082
                                    ],
                                    [
                                        46.082,
                                        -25.667
                                    ],
                                    [
                                        46.082,
                                        25.667
                                    ],
                                    [
                                        25.667,
                                        46.082
                                    ],
                                    [
                                        -25.667,
                                        46.082
                                    ],
                                    [
                                        -46.082,
                                        25.667
                                    ],
                                    [
                                        -46.082,
                                        -25.667
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.937254905701,
                                0.552941203117,
                                0.972549021244,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 1,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 14,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Chain top 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    207.222,
                    207.193,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        hasMask: true,
        masksProperties: [
            {
                inv: false,
                mode: "s",
                pt: {
                    a: 0,
                    k: {
                        i: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        o: [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        v: [
                            [
                                -15.152,
                                64.597
                            ],
                            [
                                26.152,
                                64.171
                            ],
                            [
                                26.152,
                                28.403
                            ],
                            [
                                -15.152,
                                28.829
                            ]
                        ],
                        c: true
                    },
                    ix: 1
                },
                o: {
                    a: 0,
                    k: 100,
                    ix: 3
                },
                x: {
                    a: 0,
                    k: 0,
                    ix: 4
                },
                nm: "Mask 1"
            }
        ],
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.275
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.275
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        -11.275
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.275,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        11.275
                                    ]
                                ],
                                v: [
                                    [
                                        25.667,
                                        46.082
                                    ],
                                    [
                                        -25.667,
                                        46.082
                                    ],
                                    [
                                        -46.082,
                                        25.667
                                    ],
                                    [
                                        -46.082,
                                        -25.667
                                    ],
                                    [
                                        -25.667,
                                        -46.082
                                    ],
                                    [
                                        25.667,
                                        -46.082
                                    ],
                                    [
                                        46.082,
                                        -25.667
                                    ],
                                    [
                                        46.082,
                                        25.667
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.937254905701,
                                0.552941203117,
                                0.972549021244,
                                1
                            ],
                            ix: 3,
                            x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Strokes')('Color');"
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 23.479,
                            ix: 5
                        },
                        lc: 1,
                        lj: 2,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 0,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.667
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.333
                                ],
                                y: [
                                    0
                                ]
                            },
                            t: 14,
                            s: [
                                0
                            ]
                        },
                        {
                            t: 29.0000011811942,
                            s: [
                                100
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 0,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    },
    {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Isolation Mode",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233,
                    233,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    500,
                    500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                d: 1,
                                ty: "el",
                                s: {
                                    a: 0,
                                    k: [
                                        460,
                                        460
                                    ],
                                    ix: 2
                                },
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 3
                                },
                                nm: "Ellipse Path 1",
                                mn: "ADBE Vector Shape - Ellipse",
                                hd: false
                            },
                            {
                                ty: "fl",
                                c: {
                                    a: 0,
                                    k: [
                                        0.996078431606,
                                        0.960784316063,
                                        0.996078431606,
                                        1
                                    ],
                                    ix: 4,
                                    x: "var $bm_rt;\n$bm_rt = thisComp.layer('ColorRig').effect('Fills')('Color');"
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 5
                                },
                                r: 1,
                                bm: 0,
                                nm: "Fill 1",
                                mn: "ADBE Vector Graphic - Fill",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Oval",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "icon/2tone/chain",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Chain = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Chain as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Chain.json.es.js.map
